// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".todo-calendar[data-v-7f337c73]{height:100%;overflow:auto;background:#fff;padding:8px 12px 16px}.todo-calendar__fc[data-v-7f337c73]{min-height:480px}.todo-calendar[data-v-7f337c73] .fc-event{cursor:pointer}.todo-calendar[data-v-7f337c73] .fc-daygrid-event{white-space:normal}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
